import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	EditorField
} from "~/components/Forms";

function RuleFormAdd({group, onHandleSubmit}) {

	const initialValues = {
		name: undefined,
		content : undefined
	}

	const validationSchema = Yup.object().shape({
		name: Yup.string().required('Tiêu đề quy định không được để trống'),
		content: Yup.string().required('Chi tiết quy định không được để trống'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const onSubmit = async (data) => {
		await onHandleSubmit(data, group);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<Controller control={control} name="name" render={({ field }) => (
				<InputField label="Tiêu đề" rows={5} errors={errors} {...field}/>
			)}/>
			<Controller control={control} name="content" render={({ field }) => (
				<EditorField label="Nội dung" errors={errors} {...field}/>
			)}/>
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Thêm quy định</Button>
			</div>
		</form>
	)
}

export default RuleFormAdd;